/* ELLESANTI · tema V3 · pagine categoria (prototipo V8): menu dei filtri, foglio «Filtra e ordina» su mobile, fasce di prezzo,
   filtri attivi, «Carica altri», porta gemella nell'ultima riga. I filtri sono quelli di Search & Discovery: ogni scelta chiede
   alla sezione la nuova griglia (Section Rendering API) e aggiorna l'indirizzo senza ricaricare la pagina. CTRL+G · 29/09/2026. */
(function () {
  'use strict';
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true, addEventListener: function () {} };
  var V = window.EllesantiV3 || {};

  /* la barra dei filtri si ferma sotto l'header, qualunque sia la sua altezza */
  function tbTop() {
    var hd = $('.e-hd');
    if (hd) H.style.setProperty('--e-tb-top', hd.offsetHeight + 'px');
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function setup(col) {
    var sid = col.getAttribute('data-section');
    var ctrl = null, timer = 0;
    col._band = null;

    function form() { return $('[data-e-filtri]', col); }
    function sheet() { return $('.e-fs', col); }
    function currentBand() {
      var r = $('input[name="e-fascia"]:checked', col);
      if (r) return r.value;
      var b = $('[data-e-fascia][aria-pressed="true"]', col);
      return b ? b.getAttribute('data-e-fascia') : '';
    }

    function closeAll(except) {
      $$('[data-e-fb].is-open', col).forEach(function (fb) {
        if (fb === except) return;
        fb.classList.remove('is-open');
        var b = $('[data-e-fb-btn]', fb);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    function openSheet(quiet) {
      var s = sheet();
      if (!s || mqDesk.matches) return;
      if (quiet) s.classList.add('is-quiet');
      s.classList.add('is-open');
      s.setAttribute('aria-modal', 'true');
      H.classList.add('e-lock', 'e-fs-open');
      var ob = $('[data-e-fs-open]', col);
      if (ob) ob.setAttribute('aria-expanded', 'true');
      if (quiet) setTimeout(function () { s.classList.remove('is-quiet'); }, 30);
    }
    function closeSheet() {
      var s = sheet();
      if (!s || !s.classList.contains('is-open')) return;
      s.classList.remove('is-open');
      s.setAttribute('aria-modal', 'false');
      H.classList.remove('e-lock', 'e-fs-open');
      var ob = $('[data-e-fs-open]', col);
      if (ob) { ob.setAttribute('aria-expanded', 'false'); ob.focus({ preventScroll: true }); }
    }

    function urlFromForm() {
      var f = form(), p = new URLSearchParams();
      if (f) {
        new FormData(f).forEach(function (v, k) {
          if (k === 'e-fascia') return;
          if (String(v) !== '') p.append(k, v);
        });
      }
      var band = col._band !== null ? col._band : currentBand();
      var gte = col.getAttribute('data-price-gte'), lte = col.getAttribute('data-price-lte');
      if (gte && lte) {
        p.delete(gte); p.delete(lte);
        if (band) {
          var a = band.split('-');
          if (a[0]) p.set(gte, a[0]);
          if (a[1]) p.set(lte, a[1]);
        }
      }
      var q = p.toString();
      return (col.getAttribute('data-url') || location.pathname) + (q ? '?' + q : '');
    }

    function sectionUrl(url) {
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', sid);
      return u.pathname + u.search;
    }

    function go(url) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var u = new URL(url, location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      col.classList.add('is-loading');
      var open = $$('[data-e-fb].is-open', col).map(function (fb) { return fb.getAttribute('data-e-fb'); });
      var wasSheet = sheet() && sheet().classList.contains('is-open');
      var scroll = sheet() ? ($('.e-fs__b', col) || {}).scrollTop : 0;
      fetch(sectionUrl(u.pathname + u.search), ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var fresh = $('[data-e-col]', parse(html));
          if (!fresh) { location.href = u.pathname + u.search; return; }
          col.innerHTML = fresh.innerHTML;
          Array.prototype.forEach.call(fresh.attributes, function (a) { if (a.name !== 'id') col.setAttribute(a.name, a.value); });
          col.classList.remove('is-loading');
          col._band = null;
          open.forEach(function (k) {
            var fb = $('[data-e-fb="' + k + '"]', col);
            if (fb) { fb.classList.add('is-open'); var b = $('[data-e-fb-btn]', fb); if (b) b.setAttribute('aria-expanded', 'true'); }
          });
          if (wasSheet) {
            openSheet(true);
            var b = $('.e-fs__b', col);
            if (b) b.scrollTop = scroll || 0;
          }
          try { history.replaceState(history.state, '', u.pathname + u.search); } catch (e) {}
          after(true);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          location.href = u.pathname + u.search;
        });
    }

    function more(a) {
      if (a.classList.contains('is-loading')) return;
      a.classList.add('is-loading');
      fetch(sectionUrl(a.getAttribute('href')), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var fresh = $('[data-e-col]', parse(html));
          var grid = $('[data-e-grid]', col), fg = fresh && $('[data-e-grid]', fresh);
          if (!grid || !fg) { location.href = a.href; return; }
          Array.prototype.slice.call(fg.children).forEach(function (c) { c.classList.add('is-new'); grid.appendChild(c); });
          var m = $('[data-e-more]', col), fm = $('[data-e-more]', fresh);
          if (m && fm) m.parentNode.replaceChild(fm, m);
          else if (m) m.parentNode.removeChild(m);
          after(false);
          var first = $('.is-new a', grid);
          if (first) first.focus({ preventScroll: true });
          $$('.is-new', grid).forEach(function (c) { setTimeout(function () { c.classList.remove('is-new'); }, 700); });
        })
        .catch(function () { location.href = a.href; });
    }

    function dspan() {
      var grid = $('[data-e-grid]', col);
      if (!grid) return;
      var d = $('[data-e-dtile]', grid);
      if (!d) return;
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      if (cols < 3) { d.style.gridColumn = '1 / -1'; d.setAttribute('data-span', cols); return; }
      var cells = 0;
      Array.prototype.forEach.call(grid.children, function (c) {
        if (c === d) return;
        cells += c.hasAttribute('data-e-mani') ? 4 : 1;
      });
      var rem = cols - (cells % cols);
      if (rem <= 0) rem = cols;
      d.style.gridColumn = 'span ' + rem;
      d.setAttribute('data-span', rem);
    }

    function after(full) {
      dspan();
      if (V.init) V.init(col);
      if (full && V.redraw) $$('.e-segno', col).forEach(function (s) { s.classList.add('is-drawn'); });
    }

    /* eventi (delegati: restano validi quando la sezione si aggiorna) */
    col.addEventListener('click', function (e) {
      var t = e.target;
      var b = t.closest('[data-e-fb-btn]');
      if (b && col.contains(b)) {
        var fb = b.closest('[data-e-fb]'), open = !fb.classList.contains('is-open');
        if (mqDesk.matches) closeAll(fb);
        fb.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      var fa = t.closest('[data-e-fascia]');
      if (fa && col.contains(fa)) {
        e.preventDefault();
        col._band = fa.getAttribute('aria-pressed') === 'true' ? '' : fa.getAttribute('data-e-fascia');
        $$('[data-e-fascia]', col).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-e-fascia') === col._band ? 'true' : 'false'); });
        go(urlFromForm());
        return;
      }
      var nx = t.closest('[data-e-next]');
      if (nx && col.contains(nx)) { e.preventDefault(); more(nx); return; }
      var l = t.closest('a[data-e-link]');
      if (l && col.contains(l)) { e.preventDefault(); go(l.getAttribute('href')); return; }
      if (t.closest('[data-e-fs-open]')) { openSheet(false); return; }
      if (t.closest('[data-e-fs-close]')) { closeSheet(); return; }
    });
    col.addEventListener('change', function (e) {
      var f = e.target.closest && e.target.closest('[data-e-filtri]');
      if (!f) return;
      if (e.target.name === 'e-fascia') col._band = e.target.value;
      clearTimeout(timer);
      timer = setTimeout(function () { go(urlFromForm()); }, e.target.type === 'number' ? 700 : 220);
    });
    col.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('[data-e-filtri]')) { e.preventDefault(); go(urlFromForm()); }
    });
    document.addEventListener('click', function (e) {
      if (!mqDesk.matches || !document.body.contains(col)) return;
      if (!e.target.closest || !e.target.closest('[data-e-fb]')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !document.body.contains(col)) return;
      var o = $('[data-e-fb].is-open', col);
      if (o && mqDesk.matches) { closeAll(); var b = $('[data-e-fb-btn]', o); if (b) b.focus(); return; }
      closeSheet();
    });
    var mqh = function () { closeSheet(); closeAll(); dspan(); tbTop(); };
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', mqh); else if (mqDesk.addListener) mqDesk.addListener(mqh);
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(dspan, 150); });
    dspan();
  }

  function init(scope) {
    tbTop();
    $$('[data-e-col]', scope || document).forEach(function (col) {
      if (col._eCol) return;
      col._eCol = true;
      setup(col);
    });
  }

  window.EllesantiV3 = window.EllesantiV3 || {};
  window.EllesantiV3.hooks = window.EllesantiV3.hooks || [];
  window.EllesantiV3.hooks.push(init);
  window.addEventListener('resize', tbTop);
  window.addEventListener('load', tbTop);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
